// extracted by mini-css-extract-plugin
export var container = "_fg-0";
export var segment = "_fg-2";
export var segmentActive = "_fg-3";
export var track = "_fg-1";